module.exports = __webpack_public_path__ + "static/agritech_card-0502310184ede702d014fee99ceefeec.jpg";